// extracted by mini-css-extract-plugin
export default {"icon":"breadcrumb_icon__KqqUz","svgIcon":"breadcrumb_svgIcon__SM3dJ"};